import * as React from 'react';
import { Button, Separator, Tooltip, TooltipToggle } from 'telia-front-react';
import { TranslationsContext } from '@teliaee/telia-translate';
const CardBottomPrices = (props) => {
    const { regularPrice, discounts } = props;
    const { translate } = React.useContext(TranslationsContext);
    const renderRegularPriceWithLabel = () => {
        return React.createElement("p", { className: "text-light" }, `${translate('campaignCardBottom.regularPrice', { regularPrice: regularPrice })}`);
    };
    const renderDiscountsConditionsButton = (conditionsUrl) => (React.createElement(React.Fragment, null,
        React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
        React.createElement(Button, { text: translate('campaignCardBottom.campaign.linkText'), iconLeft: "#file-pdf", link: true, target: "_blank", url: conditionsUrl, className: "text-small", iconClass: "text-primary" })));
    const getDiscountPrices = () => {
        if (!discounts) {
            return null;
        }
        if (discounts.length === 1) {
            const discount = discounts[0];
            const campaignUrl = discount.conditionsLink;
            return (React.createElement(React.Fragment, null,
                React.createElement(Separator, { spacing: "small", weight: "thin" }),
                renderPreTextAndTooltip(discount, true),
                renderRegularPriceWithLabel(),
                campaignUrl && renderDiscountsConditionsButton(campaignUrl)));
        }
        else {
            const firstDiscount = discounts[0];
            const firstCampaignUrl = firstDiscount.conditionsLink;
            const secondDiscount = discounts[1];
            const secondCampaignUrl = secondDiscount.conditionsLink;
            return (React.createElement(React.Fragment, null,
                React.createElement(Separator, { spacing: "small", weight: "thin" }),
                renderPreTextAndTooltip(firstDiscount, false),
                React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
                renderPreTextAndTooltip(secondDiscount, true),
                regularPrice && renderRegularPriceWithLabel(),
                firstCampaignUrl && renderDiscountsConditionsButton(firstCampaignUrl),
                secondCampaignUrl && renderDiscountsConditionsButton(secondCampaignUrl)));
        }
    };
    const renderPreTextAndTooltip = (discount, isSecondOrOnlyCampaign) => {
        const tooltipText = discount.tooltipText;
        const tooltipId = `discount-tooltip-${discount.id}-${Math.random().toString().substring(2)}`;
        return !!tooltipText ? (React.createElement(React.Fragment, null,
            discount.preText && React.createElement("p", null, discount.preText),
            React.createElement(Tooltip, { referenceElement: React.createElement(TooltipToggle, { id: tooltipId, className: `h4 text-bold ${isSecondOrOnlyCampaign ? 'text-campaign' : ''}` },
                    React.createElement("span", { className: `h4 text-bold ${isSecondOrOnlyCampaign ? 'text-campaign' : ''}` }, discount.price)) }, tooltipText))) : (React.createElement(React.Fragment, null,
            discount.preText && React.createElement("p", null, discount.preText),
            React.createElement("p", { className: `h4 text-bold ${isSecondOrOnlyCampaign ? 'text-campaign' : ''}` }, discount.price)));
    };
    if (discounts === null || discounts === void 0 ? void 0 : discounts.length) {
        return getDiscountPrices();
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Separator, { spacing: "small", weight: "thin" }),
        React.createElement("p", { className: "h4" }, regularPrice)));
};
export { CardBottomPrices };
